import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoVivienda: [],
  },

  getters: {
    getTipoVivienda: (state) => state.tipoVivienda,
  },

  mutations: {
    SET_TIPO_VIVIENDA(state, tipoVivienda) {
      state.tipoVivienda = tipoVivienda;
    },
  },

  actions: {
    async fetchTipoVivienda({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoVivienda')
        .then((response) => {
          commit('SET_TIPO_VIVIENDA', response.data.data);
        });
    },
  },
};
